/** @prettier */

/**
 * マニュアル
 */

import {Container, Box, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';

//Style import
import '../../css/common/common.css';

const Manual = () => {
  const trans = useTranslation().t; //翻訳関数

  return (
    <Container fixed>
      <Stack spacing={2}>
        <Box className="help__title">
          <h1>{trans('Manual.title')}</h1>
          <h2>{trans('Manual.content.instruction')}</h2>
        </Box>
        <Box className="help__body">
          <h2>{trans('Manual.content.title')}</h2>
          <h3>{trans('Manual.content.txt')}</h3>
          {/* 英語以外のマニュアル */}
          <a
            href={
              'https://www.mhi-mth.co.jp/en/products/detail/air-conditioner_users_manual.html'
            }
            id="mv-linkManualOtherLanguage"
            target="_blank"
            className={
              'help__body__list--unordered help__body__list--unordered--manual'
            }>
            {
              'For other languages : https://www.mhi-mth.co.jp/en/products/detail/air-conditioner_users_manual.html'
            }
          </a>
          <Stack
            spacing={1}
            component="ul"
            className="help__body__list--unordered help__body__list--unordered--manual">
            {/* ※注意 Amplifyの設定「書き換えてリダイレクト」にPDFを追加しないとPDFのダウンロードができない */}
            <Box component="li">
              <a
                href={`${process.env.PUBLIC_URL}/pdf/M-ACCESS_Manual_English.pdf`}
                download
                id="mv-linkManualDownload-English">
                {trans('Manual.content.item.english')}
              </a>
            </Box>
          </Stack>
        </Box>
      </Stack>
    </Container>
  );
};
export default Manual;
